/***
 * Transform data to URLSearchParams object, clean missing values
 */
export const toURLSearchParams = (searchParams: object): URLSearchParams => {
  const params = new URLSearchParams();

  Object.entries(searchParams).forEach(([key, value]) => {
    if (value !== undefined) {
      params.append(key, String(value));
    }
  });

  return params;
};

/***
 * Clean data from Nuqs and remove empty values.
 * (Nuqs uses `null` if default value is missing)
 */
export const cleanNuqsURLParams = <T extends Record<string, unknown>>(searchParams: T): Partial<T> => {
  return Object.fromEntries(
    Object.entries(searchParams as Record<string, unknown>).filter(
      ([, value]) => value !== null && value !== undefined && value !== '',
    ),
  ) as Partial<T>;
};
